import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_flipboard"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 12A12 12 0 1112 0a12 12 0 0112 12z" fill="#f52828" />
      <path d="M19 11h-4v4h-4v4H7V7h12z" fill="#fff" />
    </svg>
  );
}
